export const fileIcon: Record<string, React.ReactNode> = {
  pdf: (
    <div className="w-[35px] h-[35px] bg-[#d21a1a] rounded-[4.96px] flex justify-center items-center shadow-[0_0.31rem_0.31rem_0_#D3462638]">
      <svg xmlns="http://www.w3.org/2000/svg" width="22.39" height="22.39" viewBox="0 0 24 24">
        <g fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#ffffff">
          <path d="M7 18v-2.5m0 0V14c0-.471 0-.707.154-.854C7.308 13 7.555 13 8.05 13h.7c.725 0 1.313.56 1.313 1.25S9.475 15.5 8.75 15.5zM21 13h-1.312c-.825 0-1.238 0-1.494.244s-.256.637-.256 1.423v.833m0 2.5v-2.5m0 0h2.187m-4.375 0c0 1.38-1.175 2.5-2.625 2.5c-.327 0-.49 0-.613-.067c-.291-.16-.262-.485-.262-.766v-3.334c0-.281-.03-.606.262-.766c.122-.067.286-.067.613-.067c1.45 0 2.625 1.12 2.625 2.5" />
          <path d="M15 22h-4.273c-3.26 0-4.892 0-6.024-.798a4.1 4.1 0 0 1-.855-.805C3 19.331 3 17.797 3 14.727v-2.545c0-2.963 0-4.445.469-5.628c.754-1.903 2.348-3.403 4.37-4.113C9.095 2 10.668 2 13.818 2c1.798 0 2.698 0 3.416.252c1.155.406 2.066 1.263 2.497 2.35C20 5.278 20 6.125 20 7.818V10" />
          <path d="M3 12a3.333 3.333 0 0 1 3.333-3.333c.666 0 1.451.116 2.098-.057A1.67 1.67 0 0 0 9.61 7.43c.173-.647.057-1.432.057-2.098A3.333 3.333 0 0 1 13 2" />
        </g>
      </svg>
    </div>
  ),
  json: (
    <div className="w-[35px] h-[35px] bg-[#384a67] rounded-[4.96px] flex justify-center items-center shadow-[0_0.31rem_0.31rem_0_#3949673d]">
      <svg xmlns="http://www.w3.org/2000/svg" width="22.39" height="22.39" viewBox="0 0 24 24">
        <g fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#ffffff">
          <path d="M3.5 8.23V5.463C3.5 3.55 5.067 2 7 2s3.5 1.55 3.5 3.462v3.807A1.74 1.74 0 0 1 8.75 11A1.74 1.74 0 0 1 7 9.27V5.461" />
          <path d="M12.5 2h.273c3.26 0 4.892 0 6.024.798c.324.228.612.5.855.805c.848 1.066.848 2.6.848 5.67v2.545c0 2.963 0 4.445-.469 5.628c-.754 1.903-2.348 3.403-4.37 4.113c-1.257.441-2.83.441-5.98.441c-1.798 0-2.698 0-3.416-.252c-1.155-.406-2.066-1.263-2.497-2.35c-.268-.676-.268-1.523-.268-3.216V12" />
          <path d="M20.5 12a3.333 3.333 0 0 1-3.333 3.333c-.666 0-1.451-.116-2.098.057a1.67 1.67 0 0 0-1.179 1.179c-.173.647-.057 1.432-.057 2.098A3.333 3.333 0 0 1 10.5 22" />
        </g>
      </svg>
    </div>
  ),
  xlsx: (
    <div className="w-[35px] h-[35px] bg-[#2AB411] rounded-[4.96px] flex justify-center items-center shadow-[0_0.31rem_0.31rem_0_#2ab41138]">
      <svg
        display="inline-block"
        vertical-align="middle"
        width="22.39"
        height="22.39"
        viewBox="0 0 20 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="currentColor"
      >
        <g fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#ffffff">
          <path
            d="M17.6618,11 L16.7126,11 C16.3334,11 16.1437,11 15.9941,11.0634 C15.4847,11.2795 15.4915952,11.7873 15.4915952,12.25 C15.4915952,12.7127 15.4847,13.2205 15.9941,13.4366 C16.1437,13.5 16.3334,13.5 16.7126,13.5 C17.0919,13.5 17.2816,13.5 17.4312,13.5634 C17.9406,13.7795 17.9337048,14.2873 17.9337048,14.75 C17.9337048,15.2127 17.9406,15.7205 17.4312,15.9366 C17.2816,16 17.0919,16 16.7126,16 L15.6789,16 M5,11 L6.70791,13.5 M6.70791,13.5 L8.4158,16 M6.70791,13.5 L8.4158,11 M6.70791,13.5 L5,16 M14,16 L13.146,16 C12.3409,16 11.9384,16 11.6883,15.7559 C11.4381,15.5118 11.4381,15.119 11.4381,14.3333 L11.4381,11"
            id="形状"
          ></path>
          <path
            d="M12,20 L7.7273,20 C4.46607,20 2.83546,20 1.70307,19.2022 C1.37862,18.9736 1.09058,18.7025 0.8477,18.3971 C0,17.3313 0,15.7966 0,12.7273 L0,10.1818 C0,7.21865 0,5.73706 0.46894,4.55375 C1.22281,2.65142 2.81714,1.15088 4.83836,0.44135 C6.09563,0 7.6698,0 10.8182,0 C12.6173,0 13.5168,0 14.2352,0.2522 C15.3902,0.65765 16.3012,1.5151 16.732,2.60214 C17,3.27832 17,4.12494 17,5.81818 L17,8"
            id="路径"
          ></path>
          <path
            d="M0,10 C0,8.1591 1.49238,6.66667 3.33333,6.66667 C3.99912,6.66667 4.78404,6.78333 5.43137,6.60988 C6.00652,6.45576 6.45576,6.00652 6.60988,5.43136 C6.78333,4.78404 6.66667,3.99912 6.66667,3.33333 C6.66667,1.49238 8.1591,0 10,0"
            id="路径"
          ></path>
        </g>
      </svg>
    </div>
  ),
  csv: (
    <div className="w-[35px] h-[35px] bg-[#384A67] shadow-[0_0.31rem_0.31rem_0_#3949673d] rounded-[4.96px] flex justify-center items-center">
      <svg
        display="inline-block"
        vertical-align="middle"
        xmlns="http://www.w3.org/2000/svg"
        width="22.39"
        height="22.39"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <g fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#ffffff">
          <path d="M10.294 14.016C10.248 13.024 9.571 13 8.651 13C7.235 13 7 13.338 7 14.667v1.666C7 17.662 7.235 18 8.651 18c.92 0 1.598-.024 1.643-1.016M21 13l-1.463 3.912c-.272.725-.407 1.088-.622 1.088s-.35-.363-.622-1.088L16.83 13m-2.109 0h-.972c-.389 0-.583 0-.736.063c-.522.216-.515.724-.515 1.187s-.007.97.515 1.187c.153.063.347.063.736.063c.388 0 .583 0 .736.063c.522.216.515.724.515 1.187s.007.97-.515 1.187c-.153.063-.348.063-.736.063h-1.06" />
          <path d="M15 22h-4.273c-3.26 0-4.892 0-6.024-.798a4.1 4.1 0 0 1-.855-.805C3 19.331 3 17.797 3 14.727v-2.545c0-2.963 0-4.445.469-5.628c.754-1.903 2.348-3.403 4.37-4.113C9.095 2 10.668 2 13.818 2c1.798 0 2.698 0 3.416.252c1.155.406 2.066 1.263 2.497 2.35C20 5.278 20 6.125 20 7.818V10" />
          <path d="M3 12a3.333 3.333 0 0 1 3.333-3.333c.666 0 1.451.116 2.098-.057A1.67 1.67 0 0 0 9.61 7.43c.173-.647.057-1.432.057-2.098A3.333 3.333 0 0 1 13 2" />
        </g>
      </svg>
    </div>
  ),
  xml: (
    <div className="w-[35px] h-[35px] bg-[#384A67] shadow-[0_0.31rem_0.31rem_0_#3949673d]  rounded-[4.96px] flex justify-center items-center">
      <svg
        display="inline-block"
        vertical-align="middle"
        xmlns="http://www.w3.org/2000/svg"
        width="22.39"
        height="22.39"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <g fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#ffffff">
          <path d="m7 13l1.647 2.5m0 0l1.647 2.5m-1.647-2.5l1.647-2.5m-1.647 2.5L7 18m14 0h-.823c-.777 0-1.165 0-1.406-.244c-.242-.244-.242-.637-.242-1.423V13m-6.176 5l.342-4.165c.029-.354.043-.53.15-.563s.216.105.435.382l.873 1.104c.119.15.178.225.257.225s.139-.075.257-.225l.874-1.105c.218-.276.328-.415.434-.382c.107.033.122.21.151.563L16.471 18" />
          <path d="M15 22h-4.273c-3.26 0-4.892 0-6.024-.798a4.1 4.1 0 0 1-.855-.805C3 19.331 3 17.797 3 14.727v-2.545c0-2.963 0-4.445.469-5.628c.754-1.903 2.348-3.403 4.37-4.113C9.095 2 10.668 2 13.818 2c1.798 0 2.698 0 3.416.252c1.155.406 2.066 1.263 2.497 2.35C20 5.278 20 6.125 20 7.818V10" />
          <path d="M3 12a3.333 3.333 0 0 1 3.333-3.333c.666 0 1.451.116 2.098-.057A1.67 1.67 0 0 0 9.61 7.43c.173-.647.057-1.432.057-2.098A3.333 3.333 0 0 1 13 2" />
        </g>
      </svg>
    </div>
  ),
  pptx: (
    <div className="w-[35px] h-[35px] bg-[#D34626] shadow-[0_0.31rem_0.31rem_0_#D3462638] rounded-[4.96px] flex justify-center items-center">
      <svg
        display="inline-block"
        xmlns="http://www.w3.org/2000/svg"
        width="22.39"
        height="22.39"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <g
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          color="currentColor"
        >
          <path d="M14.786 22H10.5c-3.272 0-4.907 0-6.043-.798a4.1 4.1 0 0 1-.859-.805c-.85-1.066-.85-2.6-.85-5.67v-2.545c0-2.963 0-4.445.47-5.628C3.975 4.65 5.574 3.15 7.602 2.44C8.863 2 10.442 2 13.6 2c1.805 0 2.707 0 3.428.252c1.158.406 2.072 1.263 2.505 2.35c.268.676.268 1.523.268 3.216V10" />
          <path d="M2.807 12A3.333 3.333 0 0 1 6.14 8.667c.666 0 1.45.116 2.098-.057a1.67 1.67 0 0 0 1.179-1.18c.173-.647.056-1.432.056-2.098A3.333 3.333 0 0 1 12.807 2M7.205 17.915V13.5a.5.5 0 0 1 .5-.5h1.228c.49 0 .987.217 1.16.666c.14.362.134.687 0 1.056c-.176.483-.7.736-1.223.736H7.707M17.739 13h1.755m0 0h1.756m-1.756 0v5m-6.771-.085V13.5a.5.5 0 0 1 .5-.5h1.062c.578 0 1.16.313 1.259.871c.04.228.04.449-.004.687c-.103.57-.69.9-1.28.9h-1.537" />
        </g>
      </svg>
    </div>
  ),
  docx: (
    <div className="w-[35px] h-[35px] bg-[#1284FF] shadow-[0_0.31rem_0.31rem_0_#0c56a538] rounded-[4.96px] flex justify-center items-center">
      <svg
        display="inline-block"
        vertical-align="middle"
        xmlns="http://www.w3.org/2000/svg"
        width="22.39"
        height="22.39"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <g fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#ffffff">
          <path d="M21 14.016c-.046-.992-.723-1.016-1.643-1.016c-1.416 0-1.651.338-1.651 1.667v1.666c0 1.329.235 1.667 1.651 1.667c.92 0 1.597-.024 1.643-1.016M10.295 15.5c0 1.38-1.106 2.5-2.47 2.5c-.309 0-.463 0-.577-.067c-.275-.16-.247-.485-.247-.766v-3.334c0-.281-.028-.606.247-.766c.114-.067.268-.067.576-.067c1.365 0 2.47 1.12 2.47 2.5M14 18c-.776 0-1.165 0-1.406-.244s-.241-.637-.241-1.423v-1.666c0-.786 0-1.179.241-1.423S13.224 13 14 13s1.165 0 1.406.244s.241.637.241 1.423v1.666c0 .786 0 1.179-.241 1.423S14.776 18 14 18" />
          <path d="M15 22h-4.273c-3.26 0-4.892 0-6.024-.798a4.1 4.1 0 0 1-.855-.805C3 19.331 3 17.797 3 14.727v-2.545c0-2.963 0-4.445.469-5.628c.754-1.903 2.348-3.403 4.37-4.113C9.095 2 10.668 2 13.818 2c1.798 0 2.698 0 3.416.252c1.155.406 2.066 1.263 2.497 2.35C20 5.278 20 6.125 20 7.818V10" />
          <path d="M3 12a3.333 3.333 0 0 1 3.333-3.333c.666 0 1.451.116 2.098-.057A1.67 1.67 0 0 0 9.61 7.43c.173-.647.057-1.432.057-2.098A3.333 3.333 0 0 1 13 2" />
        </g>
      </svg>
    </div>
  ),
  txt: (
    <div className="w-[35px] h-[35px] bg-[#384a67] shadow-[0_0.31rem_0.31rem_0_#3949673d] rounded-[4.96px] flex justify-center items-center">
      <svg
        display="inline-block"
        vertical-align="middle"
        width="22.39"
        height="22.39"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <g fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#ffffff">
          <path d="M3.5 8.23V5.463C3.5 3.55 5.067 2 7 2s3.5 1.55 3.5 3.462v3.807A1.74 1.74 0 0 1 8.75 11A1.74 1.74 0 0 1 7 9.27V5.461" />
          <path d="M12.5 2h.273c3.26 0 4.892 0 6.024.798c.324.228.612.5.855.805c.848 1.066.848 2.6.848 5.67v2.545c0 2.963 0 4.445-.469 5.628c-.754 1.903-2.348 3.403-4.37 4.113c-1.257.441-2.83.441-5.98.441c-1.798 0-2.698 0-3.416-.252c-1.155-.406-2.066-1.263-2.497-2.35c-.268-.676-.268-1.523-.268-3.216V12" />
          <path d="M20.5 12a3.333 3.333 0 0 1-3.333 3.333c-.666 0-1.451-.116-2.098.057a1.67 1.67 0 0 0-1.179 1.179c-.173.647-.057 1.432-.057 2.098A3.333 3.333 0 0 1 10.5 22" />
        </g>
      </svg>
    </div>
  ),
};


fileIcon.doc = fileIcon.docx
